import { PiFlag, PiGlobe, PiTranslate, PiWarning } from 'react-icons/pi';
import { INavbarItem } from 'types/navbar/navbar.interface';

export const devToolsNavbarItems = (): INavbarItem[] => [
  {
    path: 'dev-tools/error-codes',
    name: 'error-codes',
    icon: PiWarning,
  },
  {
    path: 'dev-tools/countries',
    name: 'countries',
    icon: PiFlag,
  },
  {
    path: 'dev-tools/languages',
    name: 'languages',
    icon: PiGlobe,
  },
  {
    path: 'dev-tools/supported-languages',
    name: 'supported-languages',
    icon: PiTranslate,
  },
];
